import styled from 'styled-components';
import { Button } from 'antd';

export const Weight = styled.div`
  width: 4em;
  display: inline-block;
  margin-left: 20px;
`;

export const Share = styled.div`
  margin: 8px 0;
  display: flex;
  align-items: flex-start;
`;

export const DeleteShare = styled(Button)`
  margin-left: 20px;
  width: 32px;
  height: 32px;
`;
